import React, { useState, useEffect } from 'react';
import { Calendar } from 'primereact/calendar';

const ContactInformationForm = ({ isOpen, onClose, onSubmit, formData, warningMessage, isForceUpdate, departments = [] }) => {

    const [draftData, setDraftData] = useState(formData || {});
    const [isScholarInvalid, setIsScholarInvalid] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setDraftData(formData || {});
            if (formData && formData.GoogleScholarLink) {
                validateScholarLink(formData.GoogleScholarLink);
            } else {
                setIsScholarInvalid(false);
            }
        }
    }, [isOpen, formData]);

    if (!isOpen) return null;

    const validateScholarLink = (link) => {
        if (!link || link.trim() === '') {
            setIsScholarInvalid(false);
            return;
        }
        const scholarRegex = /^https:\/\/scholar\.google\.com\/citations\?user=[a-zA-Z0-9_-]+(&.*)?$/;
        setIsScholarInvalid(!scholarRegex.test(link.trim()));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDraftData({ ...draftData, [name]: value });

        if (name === 'GoogleScholarLink') {
            validateScholarLink(value);
        }
    };

    const handleDateChange = (name, dateObj) => {
        let dateString = '';
        if (dateObj) {
            const yyyy = dateObj.getFullYear();
            const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
            const dd = String(dateObj.getDate()).padStart(2, '0');
            dateString = `${yyyy}-${mm}-${dd}`;
        }
        handleChange({ target: { name, value: dateString } });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => setDraftData({ ...draftData, AvatarUrl: reader.result });
            reader.readAsDataURL(file);
        }
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        if (isScholarInvalid) return;
        onSubmit(draftData);
    };

    const isScholarEmpty = !draftData.GoogleScholarLink || draftData.GoogleScholarLink.trim() === '';
    const isSubmitDisabled = isScholarEmpty || isScholarInvalid;

    const renderDeptTree = (parentId = null, level = 0) => {
        return departments
            .filter(d => d.ParentId === parentId)
            .map(d => (
                <React.Fragment key={`form-dept-${d.Id}`}>
                    <option value={d.Id}>{'\u00A0'.repeat(level * 4)}{level > 0 ? '˪ ' : ''}{d.Name}</option>
                    {renderDeptTree(d.Id, level + 1)}
                </React.Fragment>
            ));
    };

    return (
        <div className="modal-overlay" style={{ zIndex: 1000 }}>
            <div className="modal-box form-modal-box" style={{ maxHeight: '95vh', overflowY: 'auto' }}>
                <div className="modal-header">
                    <h3>Chỉnh sửa thông tin cá nhân</h3>

                    {!isForceUpdate && (
                        <button
                            className="close-btn"
                            onClick={onClose}
                            style={{ fontSize: '24px', lineHeight: '1', display: 'flex', alignItems: 'center' }}
                        >
                            &times;
                        </button>
                    )}
                </div>

                <div className="modal-body" style={{ padding: '25px' }}>

                    {warningMessage && (
                        <div style={{
                            padding: '15px',
                            backgroundColor: isForceUpdate ? '#f8d7da' : '#fff3cd',
                            color: isForceUpdate ? '#721c24' : '#856404',
                            border: `1px solid ${isForceUpdate ? '#f5c6cb' : '#ffeeba'}`,
                            borderRadius: '5px',
                            marginBottom: '20px',
                            fontWeight: 'bold',
                            fontSize: '15px'
                        }}>
                            <i className="fa-solid fa-circle-exclamation" style={{ marginRight: '10px' }}></i>
                            {warningMessage}
                        </div>
                    )}

                    <form id="contactInfoForm" onSubmit={handleFormSubmit}>
                        <div className="form-grid-3">
                            <div className="form-group"><label>Họ đệm *</label><input type="text" name="LastName" className="form-input" value={draftData.LastName || ''} onChange={handleChange} required /></div>
                            <div className="form-group"><label>Tên *</label><input type="text" name="FirstName" className="form-input" value={draftData.FirstName || ''} onChange={handleChange} required /></div>
                            <div className="form-group"><label>Tên hiển thị</label><input type="text" name="DisplayName" className="form-input" value={draftData.DisplayName || ''} onChange={handleChange} /></div>
                        </div>

                        <div className="form-grid-2">
                            <div className="form-group"><label>Giới tính *</label>
                                <select name="Gender" className="form-input" value={draftData.Gender || 'Nam'} onChange={handleChange} required>
                                    <option value="Nam">Nam</option>
                                    <option value="Nữ">Nữ</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Ngày sinh *</label>
                                <Calendar
                                    id="DateOfBirth"
                                    name="DateOfBirth"
                                    value={(draftData.DateOfBirth && !isNaN(new Date(draftData.DateOfBirth).getTime())) ? new Date(draftData.DateOfBirth) : null}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    onChange={(e) => handleDateChange('DateOfBirth', e.value)}
                                    style={{ width: '100%' }}
                                    appendTo={document.body}
                                    panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                    inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-grid-2">
                            <div className="form-group"><label>Nơi sinh *</label><input type="text" name="PlaceOfBirth" className="form-input" value={draftData.PlaceOfBirth || ''} onChange={handleChange} required /></div>
                            <div className="form-group"><label>Dân tộc *</label><input type="text" name="Ethnicity" className="form-input" value={draftData.Ethnicity || ''} onChange={handleChange} required /></div>
                        </div>

                        <div className="form-grid-2">
                            <div className="form-group"><label>Quê quán *</label><input type="text" name="Hometown" className="form-input" value={draftData.Hometown || ''} onChange={handleChange} required /></div>
                            <div className="form-group"><label>Công việc được giao *</label><input type="text" name="AssignedWork" className="form-input" value={draftData.AssignedWork || ''} onChange={handleChange} required /></div>
                        </div>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label>Đơn vị công tác (Tên mô tả) *</label>
                            <input type="text" name="DepartmentName" className="form-input" value={draftData.DepartmentName || ''} onChange={handleChange} required />
                        </div>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label>Đơn vị chuyên môn *</label>
                            <select
                                name="DepartmentId"
                                className="form-input"
                                value={draftData.DepartmentId || ''}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Chọn đơn vị chuyên môn</option>
                                {renderDeptTree()}
                            </select>
                        </div>

                        <div className="form-grid-2">
                            <div className="form-group">
                                <label>Chức vụ chính quyền</label>
                                <input type="text" name="AdminPosition" className="form-input" value={draftData.AdminPosition || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Ngày bắt đầu giữ chức vụ</label>
                                <Calendar
                                    id="AdminPositionStartDate"
                                    name="AdminPositionStartDate"
                                    value={(draftData.AdminPositionStartDate && !isNaN(new Date(draftData.AdminPositionStartDate).getTime())) ? new Date(draftData.AdminPositionStartDate) : null}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    onChange={(e) => handleDateChange('AdminPositionStartDate', e.value)}
                                    style={{ width: '100%' }}
                                    appendTo={document.body}
                                    panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                    inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                                />
                            </div>
                        </div>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label>Chức vụ Đảng</label>
                            <input type="text" name="PartyPosition" className="form-input" value={draftData.PartyPosition || ''} onChange={handleChange} />
                        </div>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label>Địa chỉ liên hệ *</label>
                            <input type="text" name="ContactAddress" className="form-input" value={draftData.ContactAddress || ''} onChange={handleChange} required />
                        </div>

                        <div className="form-grid-2">
                            <div className="form-group"><label>Email *</label><input type="email" name="Email" className="form-input" value={draftData.Email || ''} onChange={handleChange} required /></div>
                            <div className="form-group"><label>Số điện thoại *</label><input type="text" name="PhoneNumber" className="form-input" value={draftData.PhoneNumber || ''} onChange={handleChange} required /></div>
                        </div>

                        <div className="form-grid-2" style={{ marginBottom: '20px' }}>
                            <div className="form-group">
                                <label style={{
                                    color: (isScholarEmpty || isScholarInvalid) ? '#c0392b' : 'inherit',
                                    fontWeight: (isScholarEmpty || isScholarInvalid) ? 'bold' : 'normal'
                                }}>
                                    Liên kết Google Scholar *
                                </label>
                                <input
                                    type="url"
                                    name="GoogleScholarLink"
                                    className="form-input"
                                    value={draftData.GoogleScholarLink || ''}
                                    onChange={handleChange}
                                    style={{
                                        borderColor: (isScholarEmpty || isScholarInvalid) ? '#e74c3c' : '#ddd',
                                        backgroundColor: (isScholarEmpty || isScholarInvalid) ? '#fadbd8' : '#fff',
                                        outline: 'none'
                                    }}
                                    placeholder="Ví dụ: https://scholar.google.com/citations?user=8wEzLYsAAAAJ"
                                    required
                                />
                                {isScholarEmpty && (
                                    <span style={{ color: '#c0392b', fontSize: '13px', marginTop: '5px', display: 'block', fontStyle: 'italic' }}>
                                        <i className="fa-solid fa-circle-xmark" style={{ marginRight: '5px' }}></i>
                                        Bạn không được để trống đường dẫn Google Scholar
                                    </span>
                                )}
                                {isScholarInvalid && !isScholarEmpty && (
                                    <span style={{ color: '#c0392b', fontSize: '13px', marginTop: '5px', display: 'block', fontStyle: 'italic' }}>
                                        <i className="fa-solid fa-circle-exclamation" style={{ marginRight: '5px' }}></i>
                                        Cấu trúc liên kết sai! Định dạng bắt buộc: https://scholar.google.com/citations?user=...
                                    </span>
                                )}
                            </div>

                            <div className="form-group">
                                <label>Định danh ORCID</label>
                                <input
                                    type="url"
                                    name="OrcidLink"
                                    className="form-input"
                                    value={draftData.OrcidLink || ''}
                                    onChange={handleChange}
                                    placeholder="Ví dụ: https://orcid.org/0000-0002-..."
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Ảnh đại diện</label>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
                                <div style={{ width: '120px', height: '120px', flexShrink: 0, backgroundColor: '#ecf0f1', borderRadius: '8px', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid #ddd' }}>
                                    {draftData.AvatarUrl ? (
                                        <img src={draftData.AvatarUrl} alt="Avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    ) : (
                                        <i className="fa-solid fa-user" style={{ fontSize: '50px', color: '#bdc3c7' }}></i>
                                    )}
                                </div>
                                <input type="file" accept="image/*" onChange={handleImageChange} style={{ fontSize: '13px', maxWidth: '100%' }} />
                            </div>
                        </div>
                    </form>
                </div>

                <div
                    className="modal-footer"
                    style={{
                        borderTop: '1px solid #eee',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '12px'
                    }}
                >
                    {!isForceUpdate && (
                        <button type="button" className="btn-cancel" onClick={onClose}>Hủy</button>
                    )}

                    <button
                        type="submit"
                        form="contactInfoForm"
                        className="btn-submit"
                        disabled={isSubmitDisabled}
                        style={{
                            opacity: isSubmitDisabled ? 0.5 : 1,
                            cursor: isSubmitDisabled ? 'not-allowed' : 'pointer',
                            pointerEvents: isSubmitDisabled ? 'none' : 'auto'
                        }}
                    >
                        {isForceUpdate ? 'Lưu & Tiếp tục' : 'Hoàn tất'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ContactInformationForm;